import React, {Fragment} from 'react';
import FormContact from "../Contact/FormContact/FormContact";

export default function About() {
        return (
            <Fragment>
                <FormContact/>
            </Fragment>
        );
    }